export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center">
          <div>
            <div className="inline-block px-3 md:px-4 py-1.5 md:py-2 bg-green-100 text-green-700 text-xs md:text-sm font-semibold rounded-full mb-4 md:mb-6 whitespace-nowrap">
              About Us
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6 leading-tight">
              Empowering <span className="text-green-600">Independent Journalism</span>
            </h2>
            {/* Desktop text */}
            <p className="hidden md:block text-lg text-gray-700 mb-6 leading-relaxed">
              <strong className="text-gray-900">The Owner Press</strong> is a decentralized media company that transforms bloggers into established news sites. We provide independent journalists with the infrastructure, distribution network, and professional support they need to succeed.
            </p>
            <p className="hidden md:block text-lg text-gray-700 mb-6 leading-relaxed">
              Our journalists maintain the <strong className="text-gray-900">highest levels of ethics</strong>, ensuring that every story is researched, verified, and reported with integrity. We believe in truth-driven journalism that serves the public interest.
            </p>
            {/* Mobile text - shorter */}
            <p className="md:hidden text-sm text-gray-700 mb-4 leading-relaxed">
              <strong className="text-gray-900">The Owner Press</strong> transforms bloggers into established news sites with professional infrastructure and global distribution.
            </p>
            <div className="bg-gradient-to-br from-gray-50 to-green-50 rounded-xl md:rounded-2xl p-6 md:p-8 border-l-4 border-green-600 shadow-sm">
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">Part of The Owner School Ecosystem</h3>
              <p className="hidden md:block text-base text-gray-700 leading-relaxed">
                The Owner Press operates within <strong className="text-gray-900">The Owner School Ecosystem</strong>, a comprehensive network dedicated to empowering entrepreneurs, creators, and professionals with the tools and knowledge they need to succeed in today's digital landscape.
              </p>
              <p className="md:hidden text-sm text-gray-700 leading-relaxed">
                Part of <strong className="text-gray-900">The Owner School Ecosystem</strong>, empowering entrepreneurs and creators.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden bg-gradient-to-br from-green-50 to-green-100 p-8 md:p-12 border-2 md:border-4 border-green-200 shadow-xl">
              <div className="text-center">
                <div className="w-20 h-20 md:w-32 md:h-32 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6 md:mb-8 shadow-lg">
                  <i className="ri-newspaper-line text-4xl md:text-6xl text-white"></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6">Our Mission</h3>
                <p className="hidden md:block text-lg text-gray-700 leading-relaxed mb-8">
                  To democratize professional journalism by providing independent reporters with enterprise-level tools, global distribution networks, and ethical frameworks that enable them to compete with traditional media outlets.
                </p>
                <p className="md:hidden text-sm text-gray-700 leading-relaxed mb-6">
                  Democratize professional journalism with enterprise-level tools and global distribution.
                </p>
                <div className="grid grid-cols-2 gap-3 md:gap-6">
                  <div className="bg-white rounded-lg md:rounded-xl p-4 md:p-6 shadow-md">
                    <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">130+</div>
                    <div className="text-xs md:text-sm font-medium text-gray-600">Distribution Outlets</div>
                  </div>
                  <div className="bg-white rounded-lg md:rounded-xl p-4 md:p-6 shadow-md">
                    <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">50+</div>
                    <div className="text-xs md:text-sm font-medium text-gray-600">CRM Integrations</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mt-12 md:mt-24">
          <div className="text-center bg-gray-50 rounded-xl p-4 md:p-6">
            <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">100%</div>
            <div className="text-xs md:text-sm font-medium text-gray-600">Ethical Standards</div>
          </div>
          <div className="text-center bg-gray-50 rounded-xl p-4 md:p-6">
            <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">130+</div>
            <div className="text-xs md:text-sm font-medium text-gray-600">Distribution Outlets</div>
          </div>
          <div className="text-center bg-gray-50 rounded-xl p-4 md:p-6">
            <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">24/7</div>
            <div className="text-xs md:text-sm font-medium text-gray-600">News Coverage</div>
          </div>
          <div className="text-center bg-gray-50 rounded-xl p-4 md:p-6">
            <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">∞</div>
            <div className="text-xs md:text-sm font-medium text-gray-600">Decentralized Network</div>
          </div>
        </div>
      </div>
    </section>
  );
}
